import { createApp } from '@vue/compat'
import { createRouter, createWebHistory } from 'vue-router'
import 'jquery'
import { DropdownPlugin, NavPlugin, NavbarPlugin, TooltipPlugin } from 'bootstrap-vue'
import Layout from './layouts/Main.vue'
import NiceDatalist from './components/NiceDatalist.vue'
import VueGtag from "vue-gtag";

import Pokemon from './pages/pokemon/Pokemon.vue'

const app = createApp(Layout)


const router = createRouter({
  history: createWebHistory(),
  routes: [
  { path: '/mapa/',
    name: 'MapIndex',
    component: () => import(/* webpackChunkName: "MapIndex" */'./pages/pokemon/PokemonIndex.vue'),
    meta: {
      title: 'Interkatywne Mapy Pokémon [Narzędzia Trenera]'
    }
  },
  { path: '/mapa/Kanto',
    name: 'Kanto',
    component: Pokemon,
    meta: {
      title: 'Gdzie złapać wszystkie Pokémony w Kanto [Red/Blue/Yellow] – Interaktywna Mapa'
    }
  },
  { path: '/mapa/Johto',
    name: 'Johto',
    component: Pokemon,
    meta: {
      title: 'Gdzie złapać wszystkie Pokémony w Johto [Gold/Silver/Crystal] – Interaktywna Mapa'
    }
  },
  { path: '/mapa/Kanto-FR-LG',
    name: 'Kanto3',
    component: Pokemon,
    meta: {
      title: 'Gdzie złapać wszystkie Pokémony w Kanto [FireRed/LeafGreen] – Interaktywna Mapa'
    }
  },
  { path: '/mapa/Hoenn',
    name: 'Hoenn',
    component: Pokemon,
    meta: {
      title: 'Gdzie złapać wszystkie Pokémony w Hoenn [Ruby/Sapphire/Emerald] – Interaktywna Mapa'
    }
  },
  { path: '/mapa/Sinnoh',
    name: 'Sinnoh',
    component: Pokemon,
    meta: {
      title: 'Gdzie złapać wszystkie Pokémony w Sinnoh [Diamond/Pearl/Platinum] – Interaktywna Mapa'
    }
  },
  { path: '/mapa/Johto-HG-SS',
    name: 'Johto4',
    component: Pokemon,
    meta: {
      title: 'Gdzie złapać wszystkie Pokémony w Johto [HeartGold/SoulSilver] – Interaktywna Mapa'
    }
  },
  { path: '/mapa/Unova',
    name: 'Unova',
    component: Pokemon,
    meta: {
      title: 'Gdzie złapać wszystkie Pokémony w Unova [Black/White] – Interaktywna Mapa'
    }
  },
  { path: '/mapa/Unova2',
    name: 'Unova2',
    component: Pokemon,
    meta: {
      title: 'Gdzie złapać wszystkie Pokémony w Unova [Black 2/White 2] – Interaktywna Mapa'
    }
  },
  { path: '/:pathMatch(.*)',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */'./pages/404.vue'),
    meta: {
      title: '404 - Strony nie znaleziono'
    }
  }
  ]
})



router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Interaktywne mapy Pokemon';
  next();
});

app.use(router)
app.use(DropdownPlugin)
app.use(NavPlugin)
app.use(NavbarPlugin)
app.use(TooltipPlugin)
app.use(VueGtag, {
  pageTrackerTemplate(to) {
    return {
      page_title: to.meta.title,
      page_path: to.path,
      page_location: window.location.href
    }
  },
  config: { id: "G-RWMV9C17V6" },
  appName: 'Mapy Pokemon',
}, router)

app.component('NiceDatalist', NiceDatalist)
app.component('Pokemon', Pokemon)

app.mount('#app')